<script>
import { Bar } from 'vue-chartjs'
export default {
  extends: Bar,
  props: {
    mainData: {
      type: Array,
      required: true
    },
  },
  watch: {
    mainData () {
      this.getChart()
    }
  },
  data() {
    return {
      chartData: null,
      options: {
        legend: {
          display: false,
        },
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: 'Avg Rejection Cycle'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    }
  },
  mounted () {
    this.getChart()
  },
  methods: {
    async getChart () {
      await this.fillChart()
      await this.renderChart(this.chartData, this.options)
    },
    fillChart () {
      this.chartData = {
        labels: this.mainData.map(n => n.full_name),
        datasets: [
          {
            label: 'Assignment Cycle',
            backgroundColor: '#99a3af',
            data: this.mainData.map(r => r.avg_change_rejection_cycles)
          },
          {
            label: 'Change Request Cycle',
            backgroundColor: '#4fb9de',
            data: this.mainData.map(r => r.avg_assignment_rejection_cycles)
          }
        ]
      }
    }
  }
}
</script>
